export default defineNuxtPlugin({
  name: 'pwa-iframe-gate',
  enforce: 'pre',
  setup () {
    if (window.self === window.top) { return; }
    navigator.serviceWorker?.getRegistrations()
      .then((registrations) => {
        for (const registration of registrations) {
          registration.unregister();
        }
      })
      .catch(() => {});
  },
});
